module.exports = __webpack_public_path__ + "static/media/project-image-3.f1b46f70.jpg";